var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21967 17.0303C8.92678 16.7374 8.92678 16.2626 9.21967 15.9697L13.1893 12L9.21967 8.03033C8.92678 7.73744 8.92678 7.26256 9.21967 6.96967C9.51256 6.67678 9.98744 6.67678 10.2803 6.96967L14.7803 11.4697C15.0732 11.7626 15.0732 12.2374 14.7803 12.5303L10.2803 17.0303C9.98744 17.3232 9.51256 17.3232 9.21967 17.0303Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#282D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRight);
export default __webpack_public_path__ + "static/media/dropdownRight.54e93816cd271a2cdaa2feacd524cdf4.svg";
export { ForwardRef as ReactComponent };